module.exports.setShippingMethodAction = (shippingMethodId) => ({
  setShippingMethod: {
    shippingMethod: shippingMethodId ? { id: shippingMethodId } : null,
  },
});
